<template>
  <div class="goodsDetail">
    <Nav />
    <van-swipe indicator-color="white" class="goods-swiper" @change="onChange">
      <van-swipe-item v-if="detail.video_url"  >
        <video
            ref='video'
            class="video_box"
            playsinline="true"
            x-webkit-airplay="true" 
            x5-playsinline="true"
            webkit-playsinline="true" 
            x5-video-player-type="h5"
            :poster="detail.pic[0].pic"
            controls
            :src="detail.video_url"
            >
          <!-- <source :src="detail.video_url" type="video/mp4"> -->
        </video>
      </van-swipe-item>
      
      <van-swipe-item v-for="item in detail.pic" :key="item.id">
        <img :src="item.pic" />
      </van-swipe-item>
      <div class="custom-indicator" slot="indicator">
        <div class="dot">{{ (current +1) + '/' + (detail.video_url ? (getLength + 1):getLength) }}</div>
      </div>
    </van-swipe>
    <div class="titleBox">
      <h4 class="title">{{ detail.title | Faddress }}</h4>
      <!-- <div class="share" @click="share">
        <img src="../assets/shop/share.png"  />
        <span>分享</span>
      </div> -->
    </div>
    <div class="subtitle" v-if="detail.selling_point">
      <span v-for="item in detail.selling_point" :key="item.id">{{ item.title }}</span>
    </div>
    <div class="price" v-if="type == 1">
      <span class="newPrice">￥{{ detail.price }}</span>
      <span class="oldPrice" v-if="detail.price_del">￥{{ detail.price_del }}</span>
    </div>
    <div class="price" v-if="type == 2">
      <span class="dingjin">定金</span>
      <span class="newPrice">￥{{ detail.price }}</span>
      <!-- <span class="oldPrice" v-if="detail.price_del">￥{{ detail.price_del }}</span> -->
    </div>
    <div class="sale">
      <span class="t1">销量：{{ detail.sell_count }}</span>
      <span v-if="type == 1">剩余{{ detail.stock_num }}件</span>
    </div>

    <div class="specs" @click="showShop">
      <span>规格</span>
      <img src="../assets/shop/spec.png" />
    </div>
    <router-link tag="div" :to="{name:'eva',query:{id:detail.id}}" class="evaluate">
      <span class="t1">评价（{{ detail.evaluate && detail.evaluate.length || 0 }}）</span>
      <div class="allEva">
        <span>全部评价</span>
        <div>></div>
      </div>
    </router-link>
    <div class="evaluateBox">
      <div class="eva_li" v-for="item in detail.evaluate" :key="item.id">
        <div class="top">
          <img :src="item.users_avatarurl" />
          <span class="name">{{ item.users_nickname }}</span>
        </div>
        <div class="time">
          <span>{{ item.add_day }}</span>
          <span>{{ item.products_sku_title }}</span>
        </div>
        <p>{{ item.content }}</p>
        <div class="imgBox" v-if="item._child">
          <div class="inner">
            <img :src="el.pic" v-for="(el,key) in item._child" :key="el.id" @click="openImg(index,key)" />
          </div>
        </div>
        <div class="reply_content" v-if="item.reply_content">商家回复：{{ item.reply_content }}</div>
      </div>
    </div>
    <div class="Detail">
      <div class="top">
        <div class="line"></div>
        <h6 v-if="type == 1">商品详情</h6>
        <h6 v-if="type == 2">服务详情</h6>
        <div class="line"></div>
      </div>
      <p class="html" style="font-size:16px;" v-html="detail.content"></p>
    </div>
    <Shop ref="shop" />
  </div>
</template>

<style lang="less">
.goodsDetail {
  .video_box{
    width: 750px;
    height: 750px;
  }
  background-color: #fff;
  .goods-swiper {
    position: relative;
    img {
      width: 750px;
      height: 750px;
    }
    .custom-indicator {
      width: 70px;
      height: 36px;
      border-radius: 18px;
      background-color: rgba(0, 0, 0, 0.6);
      text-align: center;
      color: #fff;
      position: absolute;
      font-size: 24px;
      font-weight: 400;
      right: 15px;
      bottom: 35px;
    }
  }
  .titleBox {
    padding: 0 24px;
    width: 100%;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    .title {
      font-size: 36px;
      font-weight: 500;
      line-height: 48px;
      color: #333;
      margin: 0;
      flex: 1;
    }
    .share {
      display: flex;
      align-items: center;
      flex-direction: column;
      width: 80px;
      margin-left: 5px;
      img {
        width: 42px;
        height: 42px;
      }
      span {
        font-size: 24px;
        color: #666;
      }
    }
  }
  .subtitle {
    font-size: 20px;
    color: #e42129;
    padding: 0 24px;
    margin-top: 10px;
    span {
      padding: 0 10px;
      height: 24px;
      margin-right: 10px;
      border: 1px solid #e42129;
      border-radius: 16px;
      background-color: #fff1f2;
    }
  }
  .price {
    padding: 0 24px;
    .dingjin {
      font-size: 24px;
      color: #666;
    }
    .money {
      font-size: 46px;
      color: #e42129;
      margin-left: 10px;
    }
    .newPrice {
      font-size: 46px;
      font-weight: 600;
      color: #e42129;
      margin-right: 10px;
    }
    .oldPrice {
      font-size: 24px;
      color: #aeaeae;
      text-decoration: line-through;
    }
  }
  .sale {
    width: 100%;
    padding: 0 24px;
    box-sizing: border-box;
    font-size: 24px;
    color: #666;
    margin-bottom: 20px;
    .t1 {
      margin-right: 30px;
    }
  }
  .specs {
    border-top: 1px solid #eee;
    height: 100px;
    width: 100%;
    padding: 0 24px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
    span {
      font-size: 30px;
      color: #333;
    }
    img {
      width: 40px;
    }
  }
  .evaluate {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 750px;
    height: 100px;
    padding: 0 24px;
    border-bottom: 1px solid #eee;
    box-sizing: border-box;
    .t1 {
      color: #333;
      font-size: 30px;
    }
    .allEva {
      font-size: 24px;
      color: #666;
      display: flex;
      align-items: center;
      div {
        transform: scaleY(1.5);
        padding-bottom: 3px;
        margin-left: 5px;
      }
    }
  }
  .evaluateBox {
    width: 750px;
    box-sizing: border-box;
    .eva_li {
      border-top: 1px solid #eee;
      width: 100%;
      box-sizing: border-box;
      padding: 30px 24px;
      .top {
        display: flex;
        align-items: center;
        img {
          width: 56px;
          height: 56px;
          border-radius: 50%;
          margin-right: 15px;
        }
        .name {
          font-size: 24px;
          color: #333;
        }
      }
      .time {
        height: 60px;
        display: flex;
        align-items: center;
        span {
          font-size: 22px;
          color: #666;
          margin-right: 50px;
        }
      }
      p {
        font-size: 24px;
        color: #333;
        margin: 10px 0;
      }
      .imgBox {
        width: 100%;
        padding: 0 24px;
        box-sizing: border-box;
        overflow: hidden;
        margin-top: 20px;
        .inner {
          display: flex;
          align-items: center;
          img {
            width: 140px;
            height: 140px;
            border: 1px solid #eee;
            margin-right: 20px;
          }
        }
      }
    }
  }
  .Detail {
    width: 100%;
    box-sizing: border-box;
    padding: 0 24px;
    .top {
      display: flex;
      align-items: center;
      justify-content: center;
      .line {
        height: 4px;
        width: 60px;
        background: #000;
      }
      h6 {
        font-size: 30px;
        color: #333;
        margin: 0 12px;
      }
    }
    .html {
      width: 100%;
      box-sizing: border-box;
      overflow: hidden;
      // padding: 0 5px;

      table{
        width: 100% !important;
      }
      p{
        width: 100% !important;
      }
      div{
        width: 100% !important ;
      }
      h1,h2,h3,h4,h5,h6{
        width: 100% !important;
      }
      ul,ol,li{
        width: 100% !important;
      }
      img {
        width: 710px !important;
        display: block;
      }
    }
  }

  .reply_content{
    margin-top: 12px;
    font-size: 24px;
    color: #333;
    
  }
}
</style>

<script>
import Shop from "../component/goods/goodsShop";
import { videoPlayer } from 'vue-video-player'
import 'video.js/dist/video-js.css'
export default {
  components: {
    Shop,
    VideoPlayer:videoPlayer
  },
  data() {
    return {
      current: 0,
      is_show: false,
      type: 1,
      playerOptions:{
        playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
        autoplay: false, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [{
          type: "",//这里的种类支持很多种：基本视频格式、直播、流媒体等，具体可以参看git网址项目
          src: "" //url地址
        }],
        // width: document.documentElement.clientWidth, //播放器宽度
        notSupportedMessage: '此视频暂无法播放，请稍后再试', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true  //全屏按钮
        }
      }
    };
  },
 
  created() {
    console.log(location)
      console.log('>>>>>>>>>>>')
      let { id, type } = this.$route.query;
      this.type = type;
      this.getGoodsDetail(id);
      if (!this.$store.state.isIos) {
      let url = location.href.split("#")[0];
      
      this.$http({
        url: `jsApi`,
        data: {
          url
        }
      }).then(res => {
        this.$wx.config({
          debug: false,
          appId: res.jsdata.appId,
          timestamp: res.jsdata.timestamp,
          nonceStr: res.jsdata.nonceStr,
          signature: res.jsdata.signature,
          jsApiList: ["updateAppMessageShareData","updateTimelineShareData"]
        });
      });
    }


  },
  methods: {
    onChange(e) {
      if(e !== 1) {
        this.$refs.video.pause()
      }



      this.current = e;
    },
    showShop() {
      this.$refs.shop.setIs_show();
    },
    // 获取商品详情
    getGoodsDetail(id) {
      this.$http({
        url: "goodsDetail",
        data: {
          id: id + ""
        }
      }).then(res => {

        if(res.evaluate && res.evaluate.length > 3) res.evaluate.splice(3)

        this.$store.commit("setGoodsDetail", res);
        // this.$nextTick(()=>{
        //   if(res.video_url){

        //     // document.addEventListener("WeixinJSBridgeReady", function () {

        //     //   // document.getElementById('video').play();

        //     //   // document.getElementById('video').play();
        //     //   this.$refs.video.play()


        //     // }, false);

            
            
            
        //     // this.$refs.video.pause()
        //   }
        // })


        this.$wx.ready(()=>{
           this.$wx.updateAppMessageShareData({ 
              title: '嘉贝乐商城', // 分享标题
              desc: res.title, // 分享描述
              imgUrl: res.pic[0].pic,
              link: location.href// 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            })
          
          this.$wx.updateTimelineShareData({ 
            title: '嘉贝乐商城', // 分享标题
            link: location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: res.pic[0].pic, 
          })
        })
      });
    },
    // share(){
    //   this.$wx.ready(function () {   //需在用户可能点击分享按钮前就先调用
    //     this.$wx.updateAppMessageShareData({ 
    //       title: '', // 分享标题
    //       desc: '', // 分享描述
    //       link: '', // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
    //       imgUrl: '', // 分享图标
    //       success: function () {
    //         // 设置成功
    //       }
    //     })
    //   });
    // }
  },
  computed: {
    detail() {
      let detail = this.$store.state.goodsDetail;
      if (!detail.evaluate) detail.evaluate = [];

      return detail;
    },

    getLength() {
      let arr = this.detail.pic;
      return arr.length;
    }
  }
};
</script>
